import { DownloadIcon } from '@rsos/assets/icons';
import { type PaginatedConversation } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Api';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import { SESSION_TYPE_LABELS } from '../../../../constants';
import {
  convertMillSecToMin,
  customUnixTimestamp,
  formatUnitValue,
} from '../../../../utils/helpers';
import styles from './ConversationTable.module.scss';

interface ConversationRowProps {
  conversation: PaginatedConversation;
  isChecked: boolean;
  onCheck: (id: string) => void;
  onDownload: (ids: string[]) => void;
  isDownloading: boolean;
}

const ConversationRow = ({
  conversation: d,
  isChecked,
  onCheck,
  onDownload,
  isDownloading,
}: ConversationRowProps) => {
  const duration = d.duration != null ? convertMillSecToMin(d.duration) : null;

  const sessionType = SESSION_TYPE_LABELS[d.session_type];

  return (
    <tr
      key={d.conversation_id}
      className={styles.tr}
      data-name="conversation-row"
    >
      <td className={styles.td}>
        <input
          type="checkbox"
          data-name="conversation-row-checkbox"
          checked={isChecked}
          onChange={() => onCheck(d.conversation_id)}
        />
      </td>
      <td className={styles.td}>
        {d.phone_number
          ? formatInternationalPhoneNumberHuman(d.phone_number)
          : 'N/A'}
      </td>
      <td className={styles.td}>
        {customUnixTimestamp(new Date(d.start_time).toISOString())}
      </td>
      <td className={styles.td}>{formatUnitValue(duration, 'Minute')}</td>
      <td className={styles.td}>{sessionType ?? d.session_type}</td>
      <td className={styles.td}>
        {d.status[0].toUpperCase() + d.status.slice(1)}
      </td>
      <td className={`${styles.td} ${styles.tdAction}`}>
        <button
          className={styles.rowDownloadBtn}
          onClick={() => onDownload([d.conversation_id])}
          disabled={isDownloading}
          data-tooltip="Download conversation"
          data-name="conversation-download"
        >
          <DownloadIcon width={24} height={24} />
        </button>
      </td>
    </tr>
  );
};

export default ConversationRow;
